module.exports = __webpack_public_path__ + "img/amg-gt.56fd5cb2.jpg";